import React, {useEffect, useState} from 'react';
import {getLanguage, t} from 'react-switch-lang';
import {Link, useHistory} from 'react-router-dom';
import * as yup from 'yup';
import {addRevision, getAllRevisionScopes} from '../../../../services/revisions';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';

import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import SelectList from '../../../../components/select/SelectList';
import InputDate from '../../../../components/FormFields/inputDate/InputDate';
import BackBtn from '../../../RiskComponents/pageHeader/img/arrow-left.svg';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {QUARTER, REVISION_MODE} from '../../const';
import {format} from 'date-fns';
import Textarea from '../../../../components/FormFields/Textarea';
import InputText from '../../../../components/FormFields/InputText';

const AddRevisionForm = () => {
  const lang = getLanguage();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [revisionScopesOptions, setRevisionScopesOptions] = useState([])
  const [disableRevisionScopes, setDisableRevisionScopes] = useState(true)
  const [schema, setSchema] = useState(
    yup.object().shape({
      name: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(255, `${t('message.max', {max: 255})}`),
      revisionType: yup
        .object()
        .required(t('message.fieldRequired'))
        .nullable(),
      revisionScopes: yup.array().nullable().required(t('message.fieldRequired')),
      dateOfIssue: yup.date().required(t('message.fieldRequired')).nullable(),
      revisionMode: yup
        .object()
        .required(t('message.fieldRequired'))
        .nullable(),
      description: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(10000, `${t('message.max', {max: 10000})}`),
      quarter: yup.object().required(t('message.fieldRequired')).nullable(),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const {handleSubmit, watch, setValue, errors} = methods;
 const watchRevisionType = watch('revisionType')
  const submitForm = async (data) => {
    setIsLoading(true);
    const formatIssueAtDate =
      format(new Date(data.dateOfIssue), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.dateOfIssue), 'hh:mm:ss');

    const payload = {
      revisionType: {
        id: data?.revisionType?.value,
        label: data?.revisionType.label,
        abbreviation: data?.revisionType.abbreviation,
      },
      revisionScopes: data?.revisionScopes?.map(r=> ({ id: r?.value})),
      revisionMode: data.revisionMode.value,
      issuedAt: formatIssueAtDate,
      quarter: data.quarter.label,
      description: data?.description,
      name: data?.name
    };
    try {
      const response = await addRevision(payload);
      if (response.status === 201) {
        Toast.fire({
          title: t('departments.message.addSuccess', {
            entity: t('common.revision'),
          }),
          icon: 'success',
        });
      }
      history.push('/revisions');
    } catch (err) {
      if (err.response.data.code === 'revision-reference-number-exist') {
        Swal.fire({
          text: t('revisions.revisionExists'),
          icon: 'error',
        });
      }
      else if (err.response.data.code === 'revision-name-exist') {
        Swal.fire({
          text: t('revisions.revisionWithGivenNameExists'),
          icon: 'error',
        });
      } else {
        Swal.fire({
          text: t('message.deleteFailed3', {
            entity: t('common.revision'),
          }),
          icon: 'error',
        });
      }
    }
    setIsLoading(false);
  };
  const fetchAllRevisionScopes = async () => {
    try {
      const {data} = await getAllRevisionScopes(watchRevisionType['value']);
      return data;
    } catch (e) {}
  };
  useEffect(() => {
    if (watchRevisionType?.value) {
      setDisableRevisionScopes(false)
      fetchAllRevisionScopes().then((r) => {
        let revisionScopesOptions = [];
        r.forEach((item) => {
          revisionScopesOptions.push(
            {value: item.id, label: getLanguage() === 'eng' ? item?.nameEn : item?.name}
          );
        });
        setRevisionScopesOptions(revisionScopesOptions);
      });
    }
    setValue('revisionScopes', []);
    if (watchRevisionType === null) {
      setDisableRevisionScopes(true)
      setValue('revisionScopes', [], {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRevisionType]);
  return (
    <div>
      <div className="container-fluid controls d-flex align-items-center justify-content-end">
        <Link
          to={window.location.pathname}
          className="return-btn-revisions d-flex "
          onClick={() => history.go(-1)}
        >
          <img src={BackBtn} alt="icon" />
          <span>{t('sidebar.revisions')}</span>
        </Link>
        <div className="row">
          <div className="col-12 d-flex justify-content-end"></div>
        </div>
      </div>
      <div className={'revisions-tabs-content'}>
        <FormProvider {...methods}>
          <form
            className={'revisionAddForm'}
            onSubmit={handleSubmit(submitForm)}
          >
            <div>
              <label className="label-revisionName">
                {t('revisions.revisionName')}
              </label>
              <InputText
                type="string"
                name="name"
                className="form-control input-field"
                placeholder={t('revisions.placeholder.revisionName')}
              />
            </div>
            <div>
              <label className="">{t('revisions.revisionType')}</label>
              <SelectInfinite
                className="select"
                pagination={false}
                isRevisionTypes={true}
                noSort={true}
                api="revision-types"
                name="revisionType"
                id="revisionType"
                placeholder={t('revisions.placeholder.revisionType')}
                labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              />{' '}
              <label className="pt-3">{t('revisions.area')}</label>
              <SelectList
                name="revisionScopes"
                className={errors.revisionScopesValidation && "error-field"}
                  placeholder={t('revisions.placeholder.area')}
                options={revisionScopesOptions}
                isDisabled={disableRevisionScopes}
                isMulti
              />
            </div>
            <div>
              <label className="">{t('revisions.types')}</label>
              <SelectList
                name="revisionMode"
                className="select"
                placeholder={t('revisions.placeholder.mode')}
                options={[
                  {
                    label:
                      lang === 'mne'
                        ? REVISION_MODE.REGULAR_MNE
                        : REVISION_MODE.REGULAR,
                    value: REVISION_MODE.REGULAR,
                  },
                  {
                    label:
                      lang === 'mne'
                        ? REVISION_MODE.EXTRAORDINARY_MNE
                        : REVISION_MODE.EXTRAORDINARY,
                    value: REVISION_MODE.EXTRAORDINARY,
                  },
                ]}
                isClearable
              />{' '}
            </div>
            <div>
              <label className="">{t('revisions.dateOfIssue')}</label>
              <InputDate
                name="dateOfIssue"
                className="form-control input-field dateInput"
              />
            </div>
            <div>
              <label className="">{t('revisions.quarter')}</label>
              <SelectList
                name="quarter"
                className="select"
                placeholder={t('revisions.placeholder.quarter')}
                options={[
                  {label: QUARTER.I, value: QUARTER.I},
                  {label: QUARTER.II, value: QUARTER.II},
                  {label: QUARTER.III, value: QUARTER.III},
                  {label: QUARTER.IV, value: QUARTER.IV},
                ]}
                isClearable
              />
            </div>
              <div>

              <label className="label-referentId">
                {t('revisions.description')}
              </label>
              <Textarea
                type="string"
                name="description"
                className="form-control input-field"
                placeholder={t('revisions.placeholder.description')}
                id="description"
              />
            </div>
          </form>
          <div className="container-fluid mt-4 footer">
            <div className="row">
              <div className="col-12 pt-4 pb-4 d-flex justify-content-end footer">
                <button
                  className="secondary-btn"
                  onClick={(event) => {
                    history.go(-1);
                  }}
                >
                  {t('common.cancel')}
                </button>
                <button
                  onClick={handleSubmit(submitForm)}
                  type="submit"
                  className="primary-btn"
                  disabled={isLoading}
                >
                  {t('common.save')}
                </button>
              </div>
            </div>
          </div>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddRevisionForm;
